export const CREATE_RETURNSTOCK78285 = "CREATE_RETURNSTOCK78285";
export const UPDATE_RETURNSTOCK78285 = "UPDATE_RETURNSTOCK78285";
export const DELETE_RETURNSTOCK78285 = "DELETE_RETURNSTOCK78285";
export const FETCH_RETURNSTOCK78285 = "FETCH_RETURNSTOCK78285";
export const LISTEN_TO_SELECTED_RETURNSTOCK78285 =
  "LISTEN_TO_SELECTED_RETURNSTOCK78285";
